import type { VehicleReferenceDto } from "@/lib/api";
import type { VehicleReference } from "../../types/vehicle.types";
import {
	withImageVersion,
	withImageVersions,
} from "@/utils/with-image-version/with-image-version";

export function toVehicleReference(dto: VehicleReferenceDto): VehicleReference {
	return {
		id: dto.id,
		name: dto.name,
		licensePlate: dto.licensePlate,
		imageUrl: withImageVersion(dto.imageUrls?.thumbnail300x300Url ?? undefined),
		imageUrls: withImageVersions(dto.imageUrls),
		model: dto.model,
	};
}
